import { Avatar } from '../../style-guide/Avatar/Avatar';
import clsx from 'clsx';
import React, { ReactElement } from 'react';

export interface UserDetailsProps extends React.ComponentPropsWithRef<'div'> {
  firstName: string;
  lastName: string;
  imageUrl?: string;
  organisationName?: string;
  reverse?: boolean;
}

export const UserDetails = ({
  firstName,
  lastName,
  imageUrl,
  organisationName,
  children,
  reverse,
  ...otherProps
}: UserDetailsProps): ReactElement<any> => {
  return (
    <div className="relative" {...otherProps}>
      <div className={clsx('flex items-center', reverse && `flex-row-reverse`)}>
        <Avatar firstName={firstName} lastName={lastName} src={imageUrl} size="xs" />
        <div className={reverse ? `mr-2 text-right` : `ml-2 text-left`}>
          <p className="mb-0">{`${firstName} ${lastName}`}</p>
          {organisationName && <p className="mb-0">{organisationName}</p>}
        </div>
      </div>
      {children}
    </div>
  );
};
